import { ModuleName } from './models/permission.model';

export enum SelectionTypeReleaseScope {
  All = 1,
  Inclusive = 2,
  Exclusive = 3,
}

export enum EntityType {
  Testcase = 1,
  Release = 2,
  AcceptanceCriteria = 3,
  Requirement = 4,
  Defect = 5,
  Batch = 6,
  DynamicImage = 7,
  Item = 8,
  Scenario = 9,
  TestCondition = 10,
  BusinessAcceptanceArticle = 11,
}

export enum EXTENSION_ACTION {
  Login = 'login',
  Logout = 'logout',
  Open = 'open',
}

export const ModuleItem = {
  [ModuleName.Worklist]: {
    path: '/home',
  },
  [ModuleName.Release]: {
    path: '/release',
  },
  [ModuleName.UserStories]: {
    path: '/requirement',
  },
  [ModuleName.Defect]: {
    path: '/defect',
  },
  [ModuleName.Workbench]: {
    path: '/test-case',
  },
  [ModuleName.TestLab]: {
    path: '/testlab',
  },
  [ModuleName.Document]: {
    path: '/document-management',
  },
  [ModuleName.Execute]: {
    path: '/execute',
  },
  [ModuleName.EnginuityWorkbench]: {
    path: '/enginuity-workbench',
  },
  [ModuleName.AuthoriseWorkbench]: {
    path: '/authorise-workbench',
  },
  [ModuleName.Report]: {
    path: '/reports',
  },
  [ModuleName.BatchScheduling]: {
    path: '/enginuity-batch',
  },
  [ModuleName.AuthoriseBatch]: {
    path: '/authorise-batch',
  },
  [ModuleName.VirtualTesterMonitor]: {
    path: '/virtual-tester-monitor',
  },
  [ModuleName.ServiceCatalogue]: {
    path: '/service-catalogue',
  },

  [ModuleName.AcceptanceCriteria]: {
    path: '/acceptance-criteria',
  },
  [ModuleName.Acceptance]: {
    path: '/my-dashboard',
  },
  [ModuleName.BatchAcceptanceScheduling]: {
    path: '/authorise-batch',
  },
  [ModuleName.Dashboard]: {
    path: '/dashboard',
  },
  [ModuleName.TestDesign]: {
    path: '/test-design',
  },
  [ModuleName.AIML]: {
    path: '/ai-ml',
  },
  [ModuleName.DecisionTable]: {
    path: '/decision-table',
  },
  [ModuleName.AdminFunction]: {
    path: '/setting',
  },
  [ModuleName.LicenceManagement]: {
    path: '/licence-management',
  },
};

export const saveDataToLocalStorage = (key: string, data: any) => {
  localStorage.setItem(key, JSON.stringify(data));
};

export const saveLocalStorage = (key: string, subKey: string, data: any) => {
  try {
    const storedUser = localStorage.getItem(key);
    const screenView = storedUser ? JSON.parse(storedUser) : {};

    // Kiểm tra nếu dữ liệu truyền vào là Object (và không phải Array, null)
    if (typeof data === 'object' && data !== null && !Array.isArray(data)) {
      screenView[subKey] = {
        ...(typeof screenView[subKey] === 'object' ? screenView[subKey] : {}),
        ...data,
      };
    } else {
      // Nếu là string, number, boolean, array,... thì ghi đè trực tiếp
      screenView[subKey] = data;
    }

    localStorage.setItem(key, JSON.stringify(screenView));
  } catch (error) {
    // console.error('Error saving to localStorage', error);
  }
};

export const getDataFromLocalStorage = (key: string) => {
  const raw = localStorage.getItem(key);
  const myArray = raw ? JSON.parse(raw) : [];
  return myArray;
};

export const setAntdTableSortIconNames = (tableId: string, sortKeys: string[]) => {
  const table = document.getElementById(tableId);
  if (!table) {
    return;
  }

  const validSortKeys = new Set(sortKeys);

  table.querySelectorAll<HTMLElement>('th[data-col-key]').forEach(headerCell => {
    const key = headerCell.getAttribute('data-col-key');
    if (!key || !validSortKeys.has(key)) {
      return;
    }

    const upSorter = headerCell.querySelector<HTMLElement>('.ant-table-column-sorter-up');
    const downSorter = headerCell.querySelector<HTMLElement>('.ant-table-column-sorter-down');

    if (upSorter) {
      upSorter.setAttribute('name', `sort-${tableId}-${key}-up`);
      upSorter
        .querySelectorAll<HTMLElement>('.anticon')
        .forEach(icon => icon.setAttribute('name', `sort-${tableId}-${key}-up`));
    }

    if (downSorter) {
      downSorter.setAttribute('name', `sort-${tableId}-${key}-down`);
      downSorter
        .querySelectorAll<HTMLElement>('.anticon')
        .forEach(icon => icon.setAttribute('name', `sort-${tableId}-${key}-down`));
    }
  });
};

export const observeAntdTableSortIconNames = (tableId: string, sortKeys: string[]) => {
  const table = document.getElementById(tableId);
  if (!table) {
    return null;
  }

  const scheduleUpdate = () => {
    if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(() => setAntdTableSortIconNames(tableId, sortKeys));
    } else {
      setAntdTableSortIconNames(tableId, sortKeys);
    }
  };

  const observer = new MutationObserver(() => {
    scheduleUpdate();
  });

  observer.observe(table, {
    childList: true,
    subtree: true,
  });

  scheduleUpdate();

  return observer;
};
